import {
  CHANNELS,
  PRODUCTS,
  HOME_COMMON_PARTNERS_CHANNELS,
} from "../lib/constants/appConstants";
import { TextHelper } from "../utils/TextHelper";

export const CAMPAIGN_CONFIGS = [
  {
    product: PRODUCTS.CAR,
    channel: CHANNELS.GJENSIDIGE,
    campaigns: [],
  },
  {
    product: PRODUCTS.HOME,
    channel: CHANNELS.GJENSIDIGE,
    campaigns: [
      {
        campaignDiscountPercentage: 10,
        campaignName: "Rabatt Gjensidige",
        campaignDescription: "Rabatt Gjensidige är giltig första året.",
      },
    ],
  },
  ...HOME_COMMON_PARTNERS_CHANNELS.map((channel) => ({
    product: PRODUCTS.HOME,
    channel,
    campaigns: [
      {
        campaignDiscountPercentage: 8,
        campaignName: `Rabatt ${TextHelper.getPartnerName(channel)}`,
        campaignDescription: `Rabatt ${TextHelper.getPartnerName(
          channel,
        )} är giltig första året och motsvarar 1 kostnadsfri månad.`,
      },
    ],
  })),
];
